<div id="linkedItemsPanelList" >
    <div class="card">
      <div class="card-container">
    
          <div class="items-container" *ngFor="let item of linkedItemDataToDisplay">

              <div class="overflow-ellipse flex-initial flex underline document-header font-semibold " >
              <a style="cursor: pointer;" (click)="openDocument(item?.number,item?.version)">{{ item?.number }} {{(item?.title.length>90)? 
              (item?.title | slice:0:90)+'..':(item?.title)}} (v{{ item?.version }})</a>
        </div>
          <div class="overflow-ellipse flex-initial flex" style="text-align: right;">
            <button pButton pRipple type="button" id="deleteLinkedItemButton" icon="fa fa-trash"
                     class="p-button-rounded p-button-text" appPreventDoubleClick (debounceClick)="showConfirmationPopupForDeletedAttachments(item?.number)"></button>
          </div>
          </div>
       
      </div>
    </div>                    
</div>

<p-dialog
[(visible)]="showDeleteLinkedItemsConfirmationModal"
[style]="{ width: '30vw' }"
(onHide)="closeConfirmationModal()"
[modal]="true"
>
<ng-template pTemplate="header">
<span class="font-semibold text-xl">Confirmation</span>
</ng-template>
<div>
<em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
<span>You are about to Delete linked item. Confirm?</span>
</div>
<ng-template pTemplate="footer">
  <p-button
appPreventDoubleClick
  label="No"
  type="submit"
  icon="pi pi-times"
  id="deleteLinkedItemConfirmationNoButton"
  styleClass="p-button-outlined"
  class="align-right"
  (debounceClick)="closeConfirmationModal()"
>
</p-button>
<p-button
appPreventDoubleClick
  label="Yes"
  icon="pi pi-check"
  type="submit"
  id="deleteLinkedItemConfirmationYesButton"
  class="align-right"
  (debounceClick)="updateDelegationData()"
>
</p-button>
</ng-template>
</p-dialog>
